import React from "react";
import {IMAGES, KButton, KBUTTON_SIZE, KBUTTON_TYPE, KBUTTON_VARIANT, KContainer, KSpace} from "@kopjra/uikit";
import {I18n, Translate} from "react-redux-i18n";
import {useAuth0} from "@auth0/auth0-react";

export interface StateProps {
    locale: string;
}

export interface DispatchProps {
    onGoToStore: () => void;
    onResendEmail: () => void;
}

export interface InnerProps {
}

export type Props = StateProps & DispatchProps & InnerProps;

export const Home: React.FC<Props> = ({locale, onGoToStore, onResendEmail}) => {
    const {loginWithRedirect, user} = useAuth0();
    return (
        <KContainer className={"text-center"}>
            {(user) ? (
                <>
                    <img src={IMAGES["web-trust"].still.large.dark} height={165} alt={"Web Trust"}/>
                    <KSpace/>
                    <h2 className="thinWeight">
                        <Translate value="user.confirmEmail" email={user?.email} dangerousHTML={true}/>
                    </h2>
                    <KSpace spaces={2}/>
                    <KButton
                        text={<><i className="fal fa-angle-double-right" style={{fontSize: 24, position: "relative", top: 3}}/> <Translate value="user.verified"/></>}
                        size={KBUTTON_SIZE.nm}
                        variant={KBUTTON_VARIANT.primary}
                        type={KBUTTON_TYPE.button}
                        onClick={() => window.location.reload() }
                    />
                    <KSpace spaces={2}/>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <h4><a className="link" onClick={() => onResendEmail()}><Translate value="user.resendEmailLink"/></a></h4>
                </>
            ) : (
                <>
                    <img src={IMAGES["web-trust"].still.large.default} height={165} alt={"Web Trust"}/>
                    <span className={"appName"}>Web Sign</span>
                    <KSpace/>
                    <h4><Translate value="home.payoff"/></h4>
                    <KSpace spaces={4}/>
                    <h4 className="call"><Translate value="home.call"/></h4>
                    <KSpace spaces={3}/>
                    <div>
                        <KButton
                            text={<><i className="fal fa-sign-in"/> <Translate value="user.login"/></>}
                            variant={KBUTTON_VARIANT.success}
                            size={KBUTTON_SIZE.nm}
                            onClick={() => loginWithRedirect({ui_locales: locale})}
                        />
                        <KSpace v={true} spaces={2}/>
                        <KButton
                            text={<><i className="fal fa-shopping-cart"/> <Translate value="user.buy"/></>}
                            variant={KBUTTON_VARIANT.primary}
                            size={KBUTTON_SIZE.nm}
                            onClick={() => onGoToStore()}
                        />
                    </div>
                    <KSpace spaces={2}/>
                    <h4><a className="link" href={`mailto:info@kopjra.com?subject=${I18n.t("home.contactSubject")}&body=${I18n.t("home.contactBody")}`} target="_blank" rel="noopener noreferrer"><Translate value="home.contactus"/></a></h4>
                </>
            )}
        </KContainer>
    );
}